import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {KompenzacijaDocument} from "./KompenzacijaDocument";
import {OtpremnicaDocument} from "./OtpremnicaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: osnov kompenzacije, lista priloga

export const otpremnicaDocumentFields: IntercateKeysMap<OtpremnicaDocument, EntityField<OtpremnicaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<OtpremnicaDocument>> = [
	otpremnicaDocumentFields.indexingNumber,
	otpremnicaDocumentFields.indexingDate,
	otpremnicaDocumentFields.documentNumber,
	otpremnicaDocumentFields.documentDate,
	otpremnicaDocumentFields.assignedTo,
	otpremnicaDocumentFields.clientId,
	otpremnicaDocumentFields.sectorId,
	otpremnicaDocumentFields.tags,
	otpremnicaDocumentFields.description,
	otpremnicaDocumentFields.parentId
]

export const otpremnicaDocumentFieldsDescriptor: EntityFieldsDescriptor<OtpremnicaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
